module.exports = __webpack_public_path__ + "static/img/water4.793fd9b3.webp";